export default {
  methods: {
    setPitchZoneText(data) {
      return data.pitch_zone === null
        ? "Full pitch"
        : `Pitch zone -${data.pitch_zone}`;
    },
  },
};
